var r="4.19.2";export{r as version};
//# sourceMappingURL=package.json.js.map
